// src/comps/DonationPage.jsx
import React from "react";
import { Link } from "react-router-dom";
import { Navbar } from "../App";

const DonationPage = () => {
  const methods = [
    {
      title: "United States (Zelle)",
      details: [
        "Email: abid32@hotmail.com",
        "Phone: 248-214-7122"
      ],
      isActive: true,
    },
    {
      title: "Canada (e-Transfer)",
      details: [
        "Email: syedarmanhussain@yahoo.com",
        "Phone: 1-647-888-1547"
      ],
      isActive: true,
    },
    {
      title: "Bangladesh (Bank Transfer)",
      details: [
        "⚠️ Details to be updated",
        "Bank Name: [PENDING]",
        "Account Number: [PENDING]",
        "Account Name: Spreeha BUET 88 Foundation"
      ],
      isActive: false,
    },
    {
      title: "United Kingdom",
      details: [
        "⚠️ Details to be updated",
        "Payment Method: [PENDING]",
        "Contact: [PENDING]"
      ],
      isActive: false,
    },
    {
      title: "Australia",
      details: [
        "⚠️ Details to be updated",
        "Payment Method: [PENDING]",
        "Contact: [PENDING]"
      ],
      isActive: false,
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <div className="flex flex-col items-center py-12 px-4">
        <h1 className="text-4xl font-bold mb-4 text-black">Support Our Projects</h1>
        <p className="mb-4 text-center max-w-2xl text-black text-lg">
          Your generous contributions help us continue our mission of supporting education,
          healthcare, and community welfare. Every donation makes a meaningful difference in
          the lives of those we serve.
        </p>
        <p className="mb-8 text-center max-w-xl text-black">
          Please choose your preferred payment method below to make a contribution.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-8 w-full max-w-4xl">
          {methods.map((m) => (
            <div
              key={m.title}
              className={`rounded-lg shadow-md p-6 flex flex-col ${
                m.isActive
                  ? 'bg-[#800000]'
                  : 'bg-gray-400 opacity-70'
              }`}
            >
              <h2 className="text-xl font-semibold mb-3 text-white">{m.title}</h2>
              <ul className="space-y-1 flex-1">
                {m.details.map((line, idx) => (
                  <li key={idx} className="text-white">
                    {line}
                  </li>
                ))}
              </ul>
              {!m.isActive && (
                <p className="text-white text-sm mt-3 italic">
                  Coming soon - please use alternative payment methods
                </p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-2xl bg-gray-50 border-2 border-gray-200 rounded-lg p-6">
          <h3 className="text-xl font-bold text-black mb-3">Thank You for Your Support!</h3>
          <p className="text-black mb-2">
            All donations go directly toward funding our projects in education, healthcare,
            and community support. We are grateful for your generosity.
          </p>
          <p className="text-sm text-gray-600 mt-4">
            For questions about donations or to discuss larger contributions, please contact
            us directly.
          </p>
        </div>

        <Link
          to="/projects"
          className="mt-8 bg-[#800000] text-white py-3 px-8 rounded-lg hover:bg-[#9b0000] transition"
        >
          Back to Projects
        </Link>
      </div>
    </div>
  );
};

export default DonationPage;
